import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { StyledSearch } from './index.style';

const Search = ({
  dataAttribute,
  dataAttributeName,
  search,
  value,
  name,
  title,
  options,
  open,
  onChangeOpen,
  onChange,
  creditFactorByLevel,
}) => {
  const { t } = useTranslation();

  const isChecked = (searchItem) =>
    typeof value === 'string'
      ? value === searchItem
      : value.includes(searchItem);

  const handleChangeSearch = (e) => {
    const stringType = typeof value === 'string';
    let newSearch;

    if (stringType) {
      newSearch = { ...search, [name]: e.target.value };
    } else {
      let tempSearch = value || [];
      if (e.target.checked) {
        tempSearch = [...tempSearch, e.target.value];
      } else {
        tempSearch = tempSearch.filter((item) => item !== e.target.value);
      }
      newSearch = { ...search, [name]: tempSearch };
    }
    onChange(newSearch);
  };
  return (
    <StyledSearch expanded={open} onChange={() => onChangeOpen(name)}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        classes={{ root: 'search-item-title', expanded: 'accordion-expanded' }}
      >
        <Typography variant="subtitle2">
          {title ? t(title) : t(name)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="search-item-content">
        <FormGroup aria-label="position" row className="form-group">
          {options.map((item) => (
            <div className="item-type-voice-filter">
              <FormControlLabel
                {...dataAttribute}
                {...(dataAttributeName && dataAttributeName(item?.value))}
                key={item.label}
                control={<Checkbox className="checkbox-color" />}
                labelPlacement="end"
                label={t(item.label)}
                value={item.value}
                data
                checked={isChecked(item.value)}
                onChange={handleChangeSearch}
                classes={{ label: 'checkbox-label' }}
              />
              {creditFactorByLevel?.[item?.value] > 1 && (
                <div className="x2-char-tag">
                  {t('quotaFactor', {
                    factor: creditFactorByLevel[item?.value],
                  })}
                </div>
              )}
            </div>
          ))}
        </FormGroup>
      </AccordionDetails>
    </StyledSearch>
  );
};

export default Search;
